import React, { FC } from 'react';
import Button from '@mui/material/Button';
import { TextareaAutosize } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../../shared/hooks/redux';
import { PageUnauthenticated } from '../../../../shared/components/page';
import { ChooseContactPerson } from '../../../../components/ContactPerson';
import { Header } from '../../../../components/header';
import { InnsendingLinje } from '../../../../components/Header4';
import {
  setContactPerson,
  setOrderComment,
  resetStates,
} from '../../../../core/redux/massOrderState';
import { CancelButton } from '../../../../shared/components/CancelButton';
import { Content } from '../../../../shared/components/Content';

export const InternDetaljerPage: FC = () => {
  const navigate = useNavigate();
  const {
    orderComment,
    vehicleType,
    contactPerson,
    projectTo,
  } = useSelector((s) => s.massOrderState);
  const dispatch = useDispatch();

  if (projectTo === null || vehicleType.type === 0) {
    navigate('/bestilling');
    return null;
  }

  const disableNextPage = contactPerson === null || (contactPerson?.name === '' || contactPerson?.number === '');

  return (
    <PageUnauthenticated className="tilleggsdetaljer-page parent-pos">
      <Header>Massebestilling</Header>
      <Content>
        <InnsendingLinje text="Steg 2 - Tilleggsdetaljer" styling="page-item" />

        <InnsendingLinje text="Kontaktperson" styling="page-item remove-bottom-padding" />
        <div className="page-item">
          <ChooseContactPerson
            onChange={(value) => dispatch(setContactPerson(value))}
            value={contactPerson}
          />
        </div>
        <InnsendingLinje text="Er det noe mer vi bør vite? (valgfritt)" styling="page-item remove-bottom-padding" />
        <p className="page-item">
          Spesielle forhold eller hensyn på anlegget, hvem skal motta leveransen
          eller annen nyttig informasjon som vil hjelp oss å planlegge bedre.
        </p>
        <div className="text-item flex-parent">
          <TextareaAutosize
            minRows={20}
            placeholder="Legg til kommentar"
            value={orderComment}
            className="fill-screen"
            onChange={(e) => dispatch(setOrderComment(e.target.value))}
          />
        </div>

        <div className="bottom-inner">
          <div className="bottom-element">
            <Button
              className="left-element"
              onClick={() => navigate(-1)}
              variant="contained"
              size="large"
            >
              {'<'}
            </Button>
            <CancelButton confirm={() => {
              dispatch(resetStates());
              return navigate('/bestilling');
            }}
            />
            <Button
              className="right-element"
              disabled={disableNextPage}
              onClick={() => navigate('/internkjoering/innsending')}
              variant="contained"
              size="large"
            >
              {'>'}
            </Button>
          </div>
        </div>
      </Content>
    </PageUnauthenticated>
  );
};
